{
  "__localization_test_string": "Has alcanzado el número máximo de visitas a este proveedor durante {{time_period}}. La próxima vez podrás visitar a este proveedor a partir de {{start_date}}.",
  "app_name": "Plentiful",
  "app_button_ok": "DE ACUERDO",
  "app_button_cancel": "Cancelar",
  "app_button_yes": "Sí",
  "app_button_no": "No",
  "app_button_confirm": "Confirmar",
  "app_button_try_again": "Intentar otra vez",
  "rate_the_app": "Calificar Plentiful",
  "app_textview_somethingwentwrong": "¡Algo salió mal!  Npor favor, inténtalo de nuevo",
  "app_button_logout": "Cerrar sesión",
  "app_today": "Hoy dia",
  "app_dialog_clarify_prompt": "¿Está seguro?",
  "app_personal_edittext_phone": "Número de teléfono",
  "app_personal_edittext_dob": "Fecha de nacimiento (opcional)",
  "app_personal_edittext_firstname": "Nombre",
  "app_personal_edittext_lastname": "Apellido",
  "app_personal_edittext_zipcode": "Código postal",
  "app_pantrykind_food": "Despensa de alimentos",
  "app_servicekind_reservations": "Reservas",
  "app_servicekind_line": "Línea",
  "distribution_schedule": "Horario de Distribución",
  "service_type_no_digital_options": "Solo Línea",
  "service_type_reservation_inline": "Reservas",
  "service_type_allows_pre_registration": "Permite Pre-Registro",
  "app_locationnotavailable": "Ubicación no disponible",
  "app_generalerror": "Error",
  "app_dialog_loading": "Cargando. Espere por favor…",
  "app_dialog_sms_code_title": "Código SMS",
  "app_dialog_sms_code_button_send_new_code": "Enviar un nuevo código",
  "app_release_id": "Identificador de versión de la aplicación",
  "sms_disclaimer": "Pueden aplicarse tarifas de mensajes y datos. Envía STOP para cancelar.",
  "fragment_registration_language_textview_title": "Seleccione su idioma preferido para comenzar",
  "fragment_registration_language_button_next": "Próximo",
  "fragment_registration_family_textview_title": "Cuéntenos sobre su hogar",
  "fragment_registration_family_textview_adults": "Número de adultos (18–{{senior_age_threshold_minus_one}})",
  "fragment_registration_family_textview_children": "Número de niños (menores de 18 años)",
  "fragment_registration_family_textview_seniors": "Número de personas mayores ({{senior_age_threshold}}+)",
  "fragment_registration_family_textview_notetitle": "Nota:",
  "fragment_registration_family_textview_notecontent": "Ayúdenos a brindarle un mejor servicio proporcionando detalles sobre su hogar. Nota: No se incluya entre los miembros del hogar que menciona arriba.",
  "fragment_registration_family_button_back": "Atrás",
  "fragment_registration_family_button_next": "Próximo",
  "fragment_registration_personal_textview_title": "Bienvenido a tu perfil de Plentiful",
  "fragment_registration_personal_button_back": "Atrás",
  "fragment_registration_personal_button_finish": "Terminar",
  "fragment_main_tabitem_pantrymap": "Mapa",
  "fragment_main_tabitem_pantrylist": "Lista",
  "fragment_main_bottombar_pantries": "Despensas",
  "fragment_main_bottombar_visits": "Visitas",
  "fragment_main_bottombar_messages": "Mensaje",
  "fragment_main_bottombar_profile": "Perfil",
  "cell_pantry_short_visit_date": "Vas",
  "fragment_pantrydetail_button_changetime": "Cambio de hora",
  "fragment_pantrydetail_textview_amenities": "Comodidades",
  "fragment_pantrydetail_textview_conditions": "Condiciones",
  "fragment_pantrydetail_textview_notes": "Notas de despensa",
  "fragment_pantrydetail_edittext_message": "Mensaje…",
  "fragment_pantrydetail_button_createreservation": "Programe una visita",
  "fragment_pantrydetail_button_schedulevisit": "Programar visita",
  "dialog_visittime_textview_nodatesavailable": "No hay fechas disponibles",
  "fragment_visitlist_textview_title": "Visitas",
  "fragment_visitlist_textview_zero": "Aquí es donde puede administrar sus próximos horarios de servicio. ¡Encuentra una despensa para programar una visita!",
  "fragment_messagethreadlist_textview_title": "Mensaje",
  "fragment_messagethreadlist_textview_zero": "¡Aún no hay actualizaciones!\nPara suscribirse a las actualizaciones, vaya a la página de detalles de su despensa favorita y active \"Recibir actualizaciones de esta despensa\" que se encuentra en la parte inferior de la página.",
  "fragment_profile_textview_title": "Perfil",
  "fragment_profile_button_savechanges": "Guardar cambios",
  "fragment_profile_textview_personaldetails": "Detalles personales",
  "fragment_profile_textview_language": "Idioma",
  "fragment_profile_textview_notifications": "Notificaciones",
  "fragment_profile_switch_receivenotifications": "Notificaciones Push",
  "receive_notifications_helper": "Recibe alertas en tu dispositivo",
  "fragment_profile_textview_servicedetails": "Detalles de servicio",
  "fragment_profile_switch_pickupfood": "Hago que otra persona recoja mi comida",
  "fragment_profile_edittext_pickupname": "Nombre y apellido del representante de recogida",
  "fragment_profile_edittext_pickupphone": "Número de teléfono del representante de recogida",
  "textview_baby_supplies": "¿Para cuántos niños necesita suministros para bebés (pañales, toallitas húmedas, fórmula)?",
  "fragment_profile_textview_emergencycontact": "Contacto de emergencia",
  "fragment_profile_edittext_emergencyname": "Nombre y apellido del contacto de emergencia",
  "fragment_profile_edittext_emergencyphone": "Teléfono de contacto de emergencia",
  "aiq_validation_error_regex_telephone_us": "El número de teléfono tiene un formato incorrecto",
  "fragment_profile_textview_changepersonalinfo": "Esta información se puede actualizar en cualquier despensa de alimentos abundantes.",
  "fragment_profile_edittext_feedback": "Comentario…",
  "fragment_profile_toast_feedbacksent": "Retroalimentación enviada",
  "baby_supplies": "Suministros para bebés",
  "household_size": "Tamaño del hogar",
  "food_pickup": "Recogida de alimentos",
  "emergency_contact": "Contacto de emergencia",
  "dialog_app_update_title": "Actualización disponible",
  "dialog_app_update_message": "¡La próxima versión de la aplicación está disponible en la tienda de Google Play!",
  "dialog_app_update_button_openplaystore": "Tienda de juegos abiertos",
  "app_invalid_error": "Inválido",
  "no_pantries_available": "No se encontraron resultados. Intente buscar con otro nombre de despensa o borre el cuadro de búsqueda y aleje el mapa para explorar zonas con despensas abundantes.",
  "visit_served": "servido",
  "visit_not_served": "no servido",
  "visit_no_show": "No apareciste",
  "visit_group": "Estás en el grupo {{group_number}}, pasa a las {{time}}",
  "visit_pre_registered": "Estás preinscrito, únete a la línea entre {{from_time}} - {{end_time}}",
  "pick_visit_time": "Elija el tiempo de visita",
  "received_service_on": "Visitaste el",
  "service_starts_at": "El servicio comienza en",
  "cancel_visit": "Cancelar visita",
  "confirm_cancel_visit": "¿Está seguro de que desea cancelar su visita?",
  "yes_cancel": "Si, cancelar",
  "send": "Enviar",
  "reservations_available": "Reciba actualizaciones de esta despensa",
  "report_location_issue": "Reportar un problema con esta ubicación",
  "feeding_america_network_member": "Forma parte de la red Feeding America",
  "feeding_america_find_food_link": "Visita el sitio web del banco de alimentos",
  "registration_intro": "¡Bienvenido a Plentiful! Estamos aquí para ayudarte a encontrar bancos de alimentos cerca de ti.",
  "app_personal_edittext_enter_phone": "Ingrese su número telefónico",
  "code_sent_to": "Se envió un código de inicio de sesión por SMS a",
  "account_created": "Cuenta creada",
  "get_started": "¡Comencemos!",
  "additional_details": "información adicional",
  "your_qr_code": "Tu plenti-pass",
  "id_number": "número de identificación",
  "personal_details_extra": "Información personal y preferencias",
  "settings": "Ajustes",
  "settings_extra": "Configuraciones de idioma y notificación",
  "not_verified": "Aún no verificado",
  "must_be_reverified_by": "Debe ser reverplorado por",
  "last_verified_on": "La última vez verificado en",
  "at": "en",
  "no_visit_options_available": "No hay opciones de visita disponibles para usted en este momento. Por favor consulta las condiciones de la despensa o contacta con la despensa.",
  "need_help": "¿Necesitas ayuda?",
  "email": "Correo electrónico",
  "terms_conditions": "Contrato de usuario",
  "privacy_policy": "Política de privacidad",
  "updates": "Actualizaciones",
  "family_details": "Detalles del hogar",
  "welcome_to_plentiful": "¡Bienvenidos a Plentiful!",
  "enter_email_phone": "Registrarse le permite hacer reservas y recibir actualizaciones sobre los bancos de alimentos que visite.\nSi se registró en un banco de alimentos, use el mismo número de teléfono o correo electrónico. \n¿Necesita ayuda? Contáctenos en support@plentiful.org",
  "email_or_phone": "Número de teléfono móvil o dirección de correo electrónico",
  "email_address": "Dirección de correo electrónico",
  "enter_email": "Introduce tu correo electrónico",
  "address": "Dirección",
  "email_invalid": "La dirección de correo electrónico no es válida",
  "no_sms_enabled_phone": "El número de teléfono no puede recibir mensajes de texto",
  "verification_email_sent": "¡El mensaje de verificación ha sido enviado!",
  "check_verification_email": "Revise su correo electrónico y haga clic en el botón interno para verificar su cuenta.",
  "email_verification_sent": "Te hemos enviado un correo electrónico. Haga clic en el botón del correo electrónico para verificar su dirección de correo electrónico.",
  "email_address_purpose": "para recibir recordatorios de visitas y actualizaciones importantes de Plentiful",
  "sign_up": "Inscribirse",
  "sign_in": "Iniciar sesión",
  "continue": "Continuar",
  "create_password": "Crear contraseña",
  "enter_password": "Por favor ingrese su contraseña para iniciar sesión",
  "password_info_box": "Si olvidó su contraseña o se registró en una despensa sin establecer una contraseña, utilice las siguientes opciones para iniciar sesión con magia o restablecer su contraseña.",
  "reset_password": "Restablecer contraseña",
  "password": "Contraseña",
  "eight_characters": "Al menos 8 carácteres",
  "one_special_character": "al menos 1 personaje especial",
  "one_number": "al menos un número",
  "submit": "Entregar",
  "send_magic_link": "Enviar enlace mágico",
  "magic_link_sent": "Un enlace mágico está en camino a tu bandeja de entrada.",
  "confirm_magic_link_login": "Confirmar enlace mágico Iniciar sesión",
  "sign_in_another_way": "Iniciar sesión en otra",
  "enter_phone": "Por favor, introduzca su número de teléfono",
  "skip": "Saltear",
  "optional": "Opcional",
  "enter_activation_code": "Por favor ingrese su código de inicio de sesión",
  "activation_code": "código de inicio de sesión",
  "accept_eula": "He leído y acepto los Términos de uso y Privacidad.",
  "email_verified": "Correo verificado",
  "email_verified_details": "Su dirección de correo electrónico ahora está verificada.",
  "do_not_ask_again": "No preguntes de nuevo.",
  "email_in_use": "Ya tenemos una cuenta asociada con este correo electrónico. Por favor use un correo electrónico diferente",
  "reset_password_text": "Por favor ingrese su correo electrónico para restablecer su contraseña",
  "reset_password_sent": "Restablecer contraseña Correo electrónico enviado!",
  "reset_password_sent_text": "Si tenemos una cuenta en el archivo para {{email}}, hemos enviado un enlace para restablecer su contraseña,",
  "dob_required": "Fecha de nacimiento",
  "please_verify": "Por favor verifique el teléfono o el correo electrónico en su perfil.",
  "open_profile": "Perfil abierto",
  "send_another_verification_email": "Enviar otro correo electrónico de verificación",
  "need_to_change_email": "Si necesita cambiar su dirección de correo electrónico, comuníquese con support@plentifulapp.com.",
  "need_to_change_email_or_phone": "Si necesita cambiar su dirección de correo electrónico o número de teléfono, comuníquese con support@plentifulapp.com.",
  "need_to_change_phone": "Si necesita cambiar su número de teléfono, comuníquese con support@plentifulapp.com o visite una despensa.",
  "email_subscription": "Suscripción de e-mail",
  "email_subscribed": "Correo electrónico suscrito",
  "email_unsubscribed": "Correo electrónico cancelado",
  "email_subscribed_text": "Ahora ha suscrito {{email}} a correos electrónicos abundantes",
  "email_unsubscribed_text": "Ahora ya ha desconcertado {{email}} de abundantes correos electrónicos",
  "here_to_subscribe": "Haga clic aquí para suscribirse a correos electrónicos abundantes",
  "here_to_unsubscribe": "Haga clic aquí para cancelar la suscripción de los correos electrónicos abundantes",
  "unsubscribe": "Darse de baja",
  "subscribe": "Suscribir",
  "open_profile_text": "Haga clic aquí para ir a su perfil",
  "sign_in_text": "Clic aquí para ingresar",
  "phone_assigned": "Este número de teléfono ya está en uso. Ingrese otro número de teléfono o vuelva e inicie sesión con este número de teléfono en su lugar.",
  "email_subscribe": "Actualizaciones por Email",
  "email_subscribe_helper": "Correos de las despensas que visitas y de Plentiful",
  "message_preferences": "Preferencias de Mensajes",
  "message_preferences_description": "¿Cómo te gustaría recibir recordatorios de visitas y actualizaciones?",
  "message_method_option_0": "Email y Notificaciones de la App",
  "message_method_option_1": "Preferir SMS",
  "message_method_helper_add_phone": "Agrega tu número de teléfono para recibir mensajes SMS",
  "message_method_helper_sms_opt_in": "Envía 'START' a PANTRY (726-879) para volver a recibir SMS",
  "message_method_helper_add_email": "Agrega tu correo electrónico para recibir mensajes por email",
  "message_method_helper_email_unsub": "Te has dado de baja de los correos electrónicos. Actualiza tus preferencias de email para recibirlos.",
  "message_method_helper_add_push": "Descarga la aplicación móvil para recibir notificaciones push",
  "message_method_helper_enable_push": "Habilita las notificaciones en la configuración de tu dispositivo para recibir notificaciones push",
  "password_error": "Contraseña incorrecta. Inténtalo de nuevo, restablece su contraseña, o firme de otra manera",
  "action_required": "Acción requerida",
  "otp_error": "El código no pudo ser verificado",
  "show_more": "Mostrar más",
  "pre_registration": "Registro",
  "show_less": "Muestra menos",
  "reschedule": "Reprogramar",
  "view_pantry": "Ver detalles de la despensa",
  "next_service_on": "Próximo servicio en",
  "add_birthday": "Añade tu fecha de nacimiento para desbloquear tu Plenti-Pass",
  "birthday_required": "Este pase se puede utilizar para realizar el check-in rápido y fácil en las despensas.",
  "missed_reservation_on": "Te perdiste tu reserva en",
  "delete_account": "Borrar cuenta",
  "delete_explain": "¿Estás seguro de que quieres eliminar tu cuenta? Esto cancelará todas las próximas visitas a la despensa y eliminará su cuenta. Deberá registrarse nuevamente para utilizar Plentiful.",
  "yes_delete": "Si eliminar",
  "no_cancel": "No, cancelar",
  "select_visit_reschedule": "Seleccione la visita que desea reprogramar",
  "select_visit_cancel": "Seleccione la visita que desea cancelar",
  "search_pantries": "Pantretas de búsqueda",
  "please_sign_in_or_up": "Necesitarás una cuenta abundante para continuar. Abundante es completamente libre de usar.",
  "sign_in_or_up": "Inicia sesión o regístrate para continuar",
  "country_of_birth_option_AF": "Afganistán",
  "country_of_birth_option_AX": "Islas Aland",
  "country_of_birth_option_AL": "Albania",
  "country_of_birth_option_DZ": "Argelia",
  "country_of_birth_option_AS": "Samoa Americana",
  "country_of_birth_option_AD": "Andorra",
  "country_of_birth_option_AO": "Angola",
  "country_of_birth_option_AI": "Anguila",
  "country_of_birth_option_AQ": "Antártida",
  "country_of_birth_option_AG": "Antigua y Barbuda",
  "country_of_birth_option_AR": "Argentina",
  "country_of_birth_option_AM": "Armenia",
  "country_of_birth_option_AW": "Aruba",
  "country_of_birth_option_AU": "Australia",
  "country_of_birth_option_AT": "Austria",
  "country_of_birth_option_AZ": "Azerbaiyán",
  "country_of_birth_option_BS": "bahamas",
  "country_of_birth_option_BH": "Bahrein",
  "country_of_birth_option_BD": "Bangladesh",
  "country_of_birth_option_BB": "Barbados",
  "country_of_birth_option_BY": "Bielorrusia",
  "country_of_birth_option_BE": "Bélgica",
  "country_of_birth_option_BZ": "Belice",
  "country_of_birth_option_BJ": "Benín",
  "country_of_birth_option_BM": "islas Bermudas",
  "country_of_birth_option_BT": "Bután",
  "country_of_birth_option_BO": "bolivia",
  "country_of_birth_option_BA": "Bosnia y Herzegovina",
  "country_of_birth_option_BW": "Botsuana",
  "country_of_birth_option_BV": "Isla de bouvet",
  "country_of_birth_option_BR": "Brasil",
  "country_of_birth_option_IO": "Territorio Británico del Océano Índico",
  "country_of_birth_option_BN": "Brunei Darussalam",
  "country_of_birth_option_BG": "Bulgaria",
  "country_of_birth_option_BF": "Burkina Faso",
  "country_of_birth_option_BI": "Burundi",
  "country_of_birth_option_KH": "Camboya",
  "country_of_birth_option_CM": "Camerún",
  "country_of_birth_option_CA": "Canadá",
  "country_of_birth_option_CV": "Cabo Verde",
  "country_of_birth_option_KY": "Islas Caimán",
  "country_of_birth_option_CF": "República Centroafricana",
  "country_of_birth_option_TD": "Chad",
  "country_of_birth_option_CL": "Chile",
  "country_of_birth_option_CN": "Porcelana",
  "country_of_birth_option_CX": "Isla de Navidad",
  "country_of_birth_option_CC": "Islas Cocos (Keeling)",
  "country_of_birth_option_CO": "Colombia",
  "country_of_birth_option_KM": "Comoras",
  "country_of_birth_option_CG": "Congo",
  "country_of_birth_option_CD": "Congo, la República Democrática del",
  "country_of_birth_option_CK": "Islas Cook",
  "country_of_birth_option_CR": "Costa Rica",
  "country_of_birth_option_CI": "COTE D 'IVOIRE",
  "country_of_birth_option_HR": "Croacia",
  "country_of_birth_option_CU": "Cuba",
  "country_of_birth_option_CY": "Chipre",
  "country_of_birth_option_CZ": "Republica checa",
  "country_of_birth_option_DK": "Dinamarca",
  "country_of_birth_option_DJ": "Yibuti",
  "country_of_birth_option_DM": "república dominicana",
  "country_of_birth_option_DO": "República Dominicana",
  "country_of_birth_option_EC": "Ecuador",
  "country_of_birth_option_EG": "Egipto",
  "country_of_birth_option_SV": "El Salvador",
  "country_of_birth_option_GQ": "Guinea Ecuatorial",
  "country_of_birth_option_ER": "Eritrea",
  "country_of_birth_option_EE": "Estonia",
  "country_of_birth_option_ET": "Etiopía",
  "country_of_birth_option_FK": "Islas Malvinas (Malvinas)",
  "country_of_birth_option_FO": "Islas Faroe",
  "country_of_birth_option_FJ": "Fiyi",
  "country_of_birth_option_FI": "Finlandia",
  "country_of_birth_option_FR": "Francia",
  "country_of_birth_option_GF": "Guayana francesa",
  "country_of_birth_option_PF": "Polinesia francés",
  "country_of_birth_option_TF": "Territorios Franceses del Sur",
  "country_of_birth_option_GA": "Gabón",
  "country_of_birth_option_GM": "Gambia",
  "country_of_birth_option_GE": "Georgia",
  "country_of_birth_option_DE": "Alemania",
  "country_of_birth_option_GH": "Ghana",
  "country_of_birth_option_GI": "Gibraltar",
  "country_of_birth_option_GR": "Grecia",
  "country_of_birth_option_GL": "Groenlandia",
  "country_of_birth_option_GD": "Granada",
  "country_of_birth_option_GP": "Guadalupe",
  "country_of_birth_option_GU": "Guam",
  "country_of_birth_option_GT": "Guatemala",
  "country_of_birth_option_GG": "Guerna",
  "country_of_birth_option_GN": "Guinea",
  "country_of_birth_option_GW": "Guinea-Bisáu",
  "country_of_birth_option_GY": "Guayana",
  "country_of_birth_option_HT": "Haití",
  "country_of_birth_option_HM": "Escuchada isla y islas McDonald",
  "country_of_birth_option_VA": "Santa Sede (estado de la ciudad del Vaticano)",
  "country_of_birth_option_HN": "Honduras",
  "country_of_birth_option_HK": "Hong Kong",
  "country_of_birth_option_HU": "Hungría",
  "country_of_birth_option_IS": "Islandia",
  "country_of_birth_option_IN": "India",
  "country_of_birth_option_ID": "Indonesia",
  "country_of_birth_option_IR": "Irán (República Islámica de",
  "country_of_birth_option_IQ": "Irak",
  "country_of_birth_option_IE": "Irlanda",
  "country_of_birth_option_IM": "Isla del hombre",
  "country_of_birth_option_IL": "Israel",
  "country_of_birth_option_IT": "Italia",
  "country_of_birth_option_JM": "Jamaica",
  "country_of_birth_option_JP": "Japón",
  "country_of_birth_option_JE": "Jersey",
  "country_of_birth_option_JO": "Jordán",
  "country_of_birth_option_KZ": "Kazajstán",
  "country_of_birth_option_KE": "Kenia",
  "country_of_birth_option_KI": "Kiribati",
  "country_of_birth_option_KP": "República de Corea, Popular Democrática de",
  "country_of_birth_option_KR": "Corea, república de",
  "country_of_birth_option_KW": "Kuwait",
  "country_of_birth_option_KG": "Kirguistán",
  "country_of_birth_option_LA": "República Democrática de Lao People",
  "country_of_birth_option_LV": "Letonia",
  "country_of_birth_option_LB": "Líbano",
  "country_of_birth_option_LS": "Lesoto",
  "country_of_birth_option_LR": "Liberia",
  "country_of_birth_option_LY": "Jamahiriya Árabe Libia",
  "country_of_birth_option_LI": "Liechtenstein",
  "country_of_birth_option_LT": "Lituania",
  "country_of_birth_option_LU": "Luxemburgo",
  "country_of_birth_option_MO": "macao",
  "country_of_birth_option_MK": "Macedonia, la antigua República Yugoslava de",
  "country_of_birth_option_MG": "Madagascar",
  "country_of_birth_option_MW": "Malaui",
  "country_of_birth_option_MY": "Malasia",
  "country_of_birth_option_MV": "Maldivas",
  "country_of_birth_option_ML": "Malí",
  "country_of_birth_option_MT": "Malta",
  "country_of_birth_option_MH": "Islas Marshall",
  "country_of_birth_option_MQ": "Martinica",
  "country_of_birth_option_MR": "Mauritania",
  "country_of_birth_option_MU": "Mauricio",
  "country_of_birth_option_YT": "Macho",
  "country_of_birth_option_MX": "México",
  "country_of_birth_option_FM": "Micronesia, estados federados de",
  "country_of_birth_option_MD": "Moldavia, República de",
  "country_of_birth_option_MC": "Mónaco",
  "country_of_birth_option_MN": "Mongolia",
  "country_of_birth_option_MS": "Montserrat",
  "country_of_birth_option_MA": "Marruecos",
  "country_of_birth_option_MZ": "Mozambique",
  "country_of_birth_option_MM": "Birmania",
  "country_of_birth_option_NA": "Namibia",
  "country_of_birth_option_NR": "Nauru",
  "country_of_birth_option_NP": "Nepal",
  "country_of_birth_option_NL": "Países Bajos",
  "country_of_birth_option_AN": "Antillas Holandesas",
  "country_of_birth_option_NC": "Nueva Caledonia",
  "country_of_birth_option_NZ": "Nueva Zelanda",
  "country_of_birth_option_NI": "Nicaragua",
  "country_of_birth_option_NE": "Níger",
  "country_of_birth_option_NG": "Nigeria",
  "country_of_birth_option_NU": "Niue",
  "country_of_birth_option_NF": "Isla Norfolk",
  "country_of_birth_option_MP": "Islas Marianas del Norte",
  "country_of_birth_option_NO": "Noruega",
  "country_of_birth_option_OM": "Omán",
  "country_of_birth_option_PK": "Pakistán",
  "country_of_birth_option_PW": "Palaos",
  "country_of_birth_option_PS": "Territorio Palestino, Ocupado",
  "country_of_birth_option_PA": "Panamá",
  "country_of_birth_option_PG": "Papúa Nueva Guinea",
  "country_of_birth_option_PY": "Paraguay",
  "country_of_birth_option_PE": "Perú",
  "country_of_birth_option_PH": "Filipinas",
  "country_of_birth_option_PN": "Pitcairn",
  "country_of_birth_option_PL": "Polonia",
  "country_of_birth_option_PT": "Portugal",
  "country_of_birth_option_PR": "Puerto Rico",
  "country_of_birth_option_QA": "Katar",
  "country_of_birth_option_RE": "Reunión",
  "country_of_birth_option_RO": "Rumania",
  "country_of_birth_option_RU": "Ruso",
  "country_of_birth_option_RW": "RUANDA",
  "country_of_birth_option_SH": "San Helena",
  "country_of_birth_option_KN": "Saint Kitts y Nevis",
  "country_of_birth_option_LC": "Santa Lucía",
  "country_of_birth_option_PM": "Saint Pierre y Miquelon",
  "country_of_birth_option_VC": "San Vicente y las Granadinas",
  "country_of_birth_option_WS": "Samoa",
  "country_of_birth_option_SM": "San Marino",
  "country_of_birth_option_ST": "Santo Tomé y Príncipe",
  "country_of_birth_option_SA": "Arabia Saudita",
  "country_of_birth_option_SN": "Senegal",
  "country_of_birth_option_CS": "Serbia y Montenegro",
  "country_of_birth_option_SC": "Seychelles",
  "country_of_birth_option_SL": "Sierra Leona",
  "country_of_birth_option_SG": "Singapur",
  "country_of_birth_option_SK": "Eslovaquia",
  "country_of_birth_option_SI": "Eslovenia",
  "country_of_birth_option_SB": "Islas Salomón",
  "country_of_birth_option_SO": "Somalia",
  "country_of_birth_option_ZA": "Sudáfrica",
  "country_of_birth_option_GS": "Georgia del sur y las islas Sandwich del sur",
  "country_of_birth_option_ES": "España",
  "country_of_birth_option_LK": "Sri Lanka",
  "country_of_birth_option_SD": "Sudán",
  "country_of_birth_option_SR": "Surinam",
  "country_of_birth_option_SJ": "Svalbard y Jan Mayen",
  "country_of_birth_option_SZ": "Swazilandia",
  "country_of_birth_option_SE": "Suecia",
  "country_of_birth_option_CH": "Suiza",
  "country_of_birth_option_SY": "República Árabe Siria",
  "country_of_birth_option_TW": "Taiwan, provincia de China",
  "country_of_birth_option_TJ": "Tayikistán",
  "country_of_birth_option_TZ": "Tanzania, República Unida de",
  "country_of_birth_option_TH": "Tailandia",
  "country_of_birth_option_TL": "Timor Oriental",
  "country_of_birth_option_TG": "Ir",
  "country_of_birth_option_TK": "Tokelau",
  "country_of_birth_option_TO": "Tonga",
  "country_of_birth_option_TT": "Trinidad y Tobago",
  "country_of_birth_option_TN": "Túnez",
  "country_of_birth_option_TR": "Pavo",
  "country_of_birth_option_TM": "Turkmenistán",
  "country_of_birth_option_TC": "Islas Turcas y Caicos",
  "country_of_birth_option_TV": "Tuvalu",
  "country_of_birth_option_UG": "Uganda",
  "country_of_birth_option_UA": "Ucrania",
  "country_of_birth_option_AE": "Emiratos Árabes Unidos",
  "country_of_birth_option_GB": "Reino Unido",
  "country_of_birth_option_US": "Estados Unidos",
  "country_of_birth_option_UM": "Islas periféricas menores de los Estados Unidos",
  "country_of_birth_option_UY": "Uruguay",
  "country_of_birth_option_UZ": "Uzbekistán",
  "country_of_birth_option_VU": "Vanuatu",
  "country_of_birth_option_VE": "Venezuela",
  "country_of_birth_option_VN": "Vietnam",
  "country_of_birth_option_VG": "Islas Vírgenes, Británicos",
  "country_of_birth_option_VI": "Islas Vírgenes, Estados Unidos.",
  "country_of_birth_option_WF": "Wallis y Futuna",
  "country_of_birth_option_EH": "Sahara Occidental",
  "country_of_birth_option_YE": "Yemen",
  "country_of_birth_option_ZM": "Zambia",
  "country_of_birth_option_ZW": "Zimbabue",
  "gender_option_female": "Femenino",
  "gender_option_male": "Masculino",
  "gender_option_nonconf": "Género no conforme",
  "relationship_status_option_single": "Soltero",
  "relationship_status_option_domestic_partner": "Socio doméstico",
  "relationship_status_option_common_law": "Ley común",
  "relationship_status_option_emancipated_minor": "Menor emancipado",
  "relationship_status_option_married": "Casado",
  "relationship_status_option_divorced": "Divorciado",
  "relationship_status_option_separated": "Apartado",
  "relationship_status_option_widowed": "Viudo",
  "housing_option_own": "Propio",
  "housing_option_room_in_apartment": "Habitación en apartamento",
  "housing_option_friends_or_family": "Amigos o familiares",
  "housing_option_regular_rent": "Alquiler regular",
  "housing_option_subsidized_rent": "Alquiler subsidiado",
  "housing_option_shelter": "Refugio",
  "housing_option_homeless": "Sin hogar",
  "employment_option_full_time": "Tiempo completo",
  "employment_option_part_time": "Tiempo parcial",
  "employment_option_unemployed": "Desempleados",
  "education_option_no_high_school": "Sin escuela secundaria",
  "education_option_high_school_diploma": "Diploma de escuela secundaria",
  "education_option_ged": "GED",
  "education_option_associate_or_bachelo": "Título asociado o licenciatura",
  "education_option_post_graduate": "Estudios de posgrado",
  "ethnicity_option_two_or_more_races": "Dos o mas carreras",
  "ethnicity_option_black": "Negro (no hispano)",
  "ethnicity_option_white": "Blanco (no hispano)",
  "ethnicity_option_hispanic_or_latino": "Hispano o latino",
  "ethnicity_option_asian_or_pacific": "Asiático o isleño del Pacífico",
  "ethnicity_option_american_indian_or_alaskan": "Indio americano o de Alaska",
  "ethnicity_option_other": "Otro",
  "snap_benefits": "Programa de asistencia de nutrición suplementaria",
  "wic_benefits": "Programa de nutrición suplementaria para mujeres, bebés y niños.",
  "tanf_benefits": "Asistencia temporal para familias necesitadas.",
  "medicaid_benefits": "Seguro de salud pública para personas con bajos ingresos.",
  "ssi_benefits": "Programa de ingresos de seguridad suplementarios",
  "free_reduced_meals": "Programa de comida libre o reducida.",
  "tefap_form": "Certificación TEFAP",
  "tefap_form_expired": "Su testación de TEFAP expiró en",
  "tefap_form_usda_title": "Declaración de no discriminación del USDA",
  "tefap_form_usda_subheader": "Tenga en cuenta lo siguiente",
  "tefap_form_usda_body": "<p>De conformidad con la ley federal de derechos civiles y las normas y políticas de derechos civiles del Departamento de Agricultura de los Estados Unidos (USDA), el USDA, sus agencias, oficinas y empleados, y las instituciones que participan o administran programas del USDA tienen prohibido discriminar por motivos de raza, color, origen nacional, religión, sexo, orientación sexual, discapacidad, edad, estado civil, estado familiar/parental, ingresos derivados de un programa de asistencia pública, creencias políticas o represalias o retaliación por actividades previas de derechos civiles, en cualquier programa o actividad realizada o financiada por el USDA (no todas las bases se aplican a todos los programas). Los recursos y los plazos para presentar quejas varían según el programa o incidente.</p><p>Las personas con discapacidades que requieran medios alternativos de comunicación para obtener información sobre el programa (por ejemplo, Braille, letra grande, cintas de audio, lenguaje de señas estadounidense, etc.) deben comunicarse con la agencia responsable o con el Centro TARGET del USDA al (202) 720-2600 (voz y TTY) o comunicarse con el USDA a través del Servicio Federal de Retransmisión al (800) 877-8339. Además, la información sobre el programa puede estar disponible en otros idiomas además del inglés.</p><p>Para presentar una queja por discriminación en un programa, complete el Formulario de queja por discriminación en un programa del USDA, AD-3027, que se encuentra en línea en <a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">Cómo presentar una queja por discriminación en un programa</a> y en cualquier oficina del USDA o escriba una carta dirigida al USDA y proporcione en la carta toda la información solicitada en el formulario. Para solicitar una copia del formulario de queja, llame al (866) 632-9992. Envíe su formulario o carta completos al USDA por: (1) correo postal: Departamento de Agricultura de los EE. UU., Oficina del Secretario Adjunto de Derechos Civiles, 1400 Independence Avenue, SW, Washington, DC 20250-9410; (2) fax: (202) 690-7442; o (3) correo electrónico: <a href=\"mailto:program.intake@usda.gov\">program.intake@usda.gov</a>.</p><p>El USDA es un proveedor, empleador y prestamista que ofrece igualdad de oportunidades.</p>",
  "app_button_next": "Próximo",
  "app_button_back": "Atrás",
  "app_button_submit": "Entregar",
  "app_button_close": "Cerrar",
  "app_button_done": "Listo",
  "form_required": "Requerido *",
  "benefits": "Programas de beneficios",
  "benefits_extra": "Detalles sobre los programas de beneficios",
  "help_and_support": "Estamos aquí para ayudar",
  "help_and_support_extra": "Preguntas frecuentes e información de contacto",
  "frequently_asked_questions": "Preguntas frecuentes",
  "contact_support": "Contacte con el soporte de Plentiful",
  "optional_details": "Detalles opcionales",
  "address_street_1": "Dirección",
  "address_street_2": "Apto",
  "city": "Ciudad",
  "state": "Estado",
  "zipcode": "Código postal",
  "additional_optional_details": "Detalles adicionales",
  "gender": "Género",
  "relationship_status": "Estado civil",
  "ethnicity": "Etnicidad",
  "country_of_birth": "País de nacimiento",
  "employment": "Empleo",
  "highest_education_obtained": "Educación",
  "food_preferences": "Preferencias de comida",
  "housing_details": "Detalles de la vivienda",
  "housing_status": "Estado de la vivienda",
  "special_circumstances": "Circunstancias especiales",
  "needs_assistance": "Necesito ayuda en las despensas",
  "dont_need_assistance": "No necesito ayuda en las despensas.",
  "aiq_validation_error_min_adult_family_members": "Los miembros adultos del hogar deben ser mayores de 0",
  "aiq_validation_error_max_adult_family_members": "Los miembros adultos del hogar no pueden ser mayores de 10",
  "aiq_validation_error_min_child_family_members": "Los miembros del hogar infantil deben ser mayores de 0",
  "aiq_validation_error_max_child_family_members": "Los miembros del hogar infantil no pueden ser mayores de 10",
  "aiq_validation_error_min_senior_family_members": "Los miembros mayores del hogar deben ser mayores de 0",
  "aiq_validation_error_max_senior_family_members": "Los miembros mayores del hogar no pueden ser mayores de 10",
  "aiq_validation_error_required_emergency_contact": "Se requiere información de contacto de emergencia",
  "aiq_validation_error_required_pick_up_name": "Se requiere información del nombre del representante",
  "aiq_validation_error_required_birth_date": "Información de la fecha de nacimiento es requerida",
  "aiq_validation_error_regex_zip_code": "Código postal debe ser numérico",
  "aiq_validation_error_required_first_name": "El nombre es obligatorio",
  "aiq_validation_error_required_last_name": "Se requiere apellido",
  "aiq_validation_error_min_baby_supplies": "Suministros de bebé deben ser mayores que 0",
  "aiq_validation_error_max_baby_supplies": "Suministros de bebé no pueden ser mayores que 10",
  "dietary_preferences_option_lactose": "Intolerancia a la lactosa",
  "dietary_preferences_option_gluten": "Intolerancia al gluten",
  "dietary_preferences_option_kosher": "Comestible según la ley judía",
  "dietary_preferences_option_halal": "Halal",
  "dietary_preferences_option_dairy_free": "Libre de lácteos",
  "dietary_preferences_option_vegetarian": "Vegetariano",
  "dietary_preferences_option_vegan": "Vegano",
  "dietary_preferences_option_fodmap": "FODMAP",
  "dietary_preferences_option_nut_allergy": "Alergias a los frutos secos y al maní",
  "dietary_preferences_option_fish_allergy": "Alergias a pescados y mariscos",
  "dietary_preferences_option_none": "Sin preferencias",
  "tefap_additional_info_requested": "Información adicional solicitada",
  "tefap_zipcode_correct": "¿Es correcto su código postal?",
  "tefap_address_correct": "¿Es correcta su dirección?",
  "tefap_participate_in_programs": "¿Alguien en su hogar participa en alguno de los siguientes programas? ",
  "tefap_check_all_that_apply": "Por favor seleccione todas las respuestas válidas. Si no hay ninguno, toque Próximo para ver más opciones.",
  "tefap_household_numbers_correct": "¿Son correctan el número de personas en su hogar?",
  "tefap_household_dont_include_yourself": "Por favor, no se incluya en esta pantalla. TEFAP solo requiere el tamaño total de su hogar, pero Plentiful muestra la información que proporcionó anteriormente.",
  "tefap_income_at_or_below_question": "Es su ingreso en o por debajo",
  "tefap_for_household_size": "Para su hogar de",
  "tefap_retake_attestation": "¿Quieres volver a tomar la atestación?",
  "tefap_attestation_completed": "Ha completado con éxito el formulario de certificación TEFAP.",
  "tefap_thank_you": "¡Gracias!",
  "tefap_is_recorded": "Su atestación TEFAP ha sido registrada. Puedes retomarlo en tu perfil.",
  "tefap_sign_below": "Tu nombre (opcional)",
  "tefap_legal_signing": "Al firmar a continuación, declaro que mi ingreso de todas las fuentes no excede los ingresos mencionados anteriormente para los hogares con el mismo número de personas que mi hogar o que mi hogar participa en el (los) programa (s) que he comprobado en este formulario. Entiendo que estos registros se mantendrán en confianza en este sitio de distribución, pero pueden ser liberados a la Oficina de Servicios Generales del Estado de Nueva York o al Departamento de Agricultura de los Estados Unidos para su revisión a su solicitud.",
  "tefap_retake": "Volver a tomar",
  "program_complete_now": "Complete ahora",
  "program_complete_later": "Completar más tarde",
  "reservation_confirmed": "Visita confirmada",
  "tefap_reservation_confirmed": "¡Tu visita está confirmada!",
  "pre_registration_confirmed": "Visita confirmada",
  "your_upcoming_reservation": "Su próxima visita",
  "your_upcoming_pre_registration": "Su próxima visita",
  "tefap_attestation_needed": "Esta despensa está solicitando su atestación TEFAP.",
  "tefap_attestation_complete_now": "Compléelo ahora y ahorre tiempo en su próxima visita de despensa.",
  "tefap_description": "A través del Programa de Asistencia Alimentaria de Emergencia (TEFAP), el USDA brinda apoyo alimentario a su comunidad local, poniéndolo a su disposición a través de agencias comunitarias como comedores comunitarios y despensas de alimentos.",
  "tefap_what_is_tefap": "¿Qué es TEFAP?",
  "tefap_confirm_share_with_pantry": "Confirme que desea compartir la siguiente información con esta despensa.",
  "tefap_thanks_for_sharing": "¡Gracias por proporcionar la información adicional solicitada por la despensa!",
  "tefap_continue_make_reservation": "Continuar programando una visita",
  "tefap_pantry_is_requesting": "Esta despensa está solicitando su",
  "tefap_missing_information": "Información faltante",
  "tefap_pantry_will_ask": "Haga clic en \"Siguiente\" para agregar esta información. Si la omite, la despensa la solicitará en su próxima visita.",
  "tefap_submission_pending": "Enviando tus respuestas a la despensa...",
  "cancel_edit": "Cancelar Editar",
  "edit": "Editar",
  "select": "Seleccione",
  "can_prepare_food": "Puede preparar comida",
  "cannot_prepare_food": "No se puede preparar comida",
  "pantry_details_prompt_title": "{{programName}} necesario",
  "pantry_details_prompt_without_visit_label": "Esta despensa está usando {{programName}} para el registro. Tendrás preguntas adicionales para responder cuando llegues a la despensa.",
  "pantry_details_prompt_visit_label": "Esta despensa está usando {{programName}} para el registro. Ahorre tiempo en su próxima visita respondiendo a estas preguntas en línea.",
  "state_program_attestation_cannot_complete": "Lo sentimos, pero no podemos completar su certificación en este momento. Puede intentar nuevamente más tarde, contactar al soporte, o completar esto cuando llegue a la despensa.",
  "state_program_attestation_submitted": "¡Gracias por completar la certificación de {{programName}}! Sus respuestas han sido enviadas exitosamente a la despensa. Este es el final de las preguntas de {{programName}}, y cualquier otra pregunta proviene de otros programas de Plentiful.",
  "state_program_cancel_confirmation": "¿Está seguro de que desea cancelar su certificación para {{programName}}? Es posible que aún necesite responder estas preguntas cuando visite la despensa.",
  "state_program_cancel_attestation": "Cancelar Certificación",
  "state_program_resume_attestation": "Reanudar Certificación",
  "tefap_no_submit": "No, someter",
  "tefap_yes_retake": "Si, retomar",
  "tefap_expires": "Expira",
  "tefap_incomplete": "Incompleto, complételo ahora para ahorrar tiempo en su próxima visita a la despensa.",
  "tefap_none": "Ninguna",
  "tefap_benefit_programs_select": "Seleccione su inscripción en los siguientes programas",
  "tefap_pantry_requests_info": "Esta despensa está solicitando información adicional para su próxima visita.",
  "tefap_eligible": "Eres elegible",
  "tefap_not_eligible": "Usted no es elegible",
  "tefap_receive_product": "para recibir el producto TEFAP",
  "tefap_eligible_program": "Participas en el siguiente programa.",
  "tefap_eligible_programs": "Participas en los siguientes programas.",
  "tefap_not_eligible_program": "No participas en ningún programa.",
  "tefap_household_income": "su ingreso familiar para",
  "tefap_info_changed": "¿Ha cambiado recientemente su información de elegibilidad de TEFAP (participación en programas de beneficios, tamaño del hogar y / o ingresos)?",
  "tefap_still_get_food": "Todavía puede recibir alimentos que no sean de TEFAP de despensa.",
  "tefap_form_checking_here": "Al marcar aquí, usted da fe de que lo siguiente es cierto:",
  "tefap_form_checking_1": "1. El nombre, la dirección y el tamaño del hogar del destinatario proporcionados anteriormente son correctos.",
  "tefap_form_checking_2_CO": "2. El beneficiario reside dentro de Colorado (no se requiere una duración mínima de residencia).",
  "tefap_form_checking_2_NY": "2. El destinatario reside dentro del estado de Nueva York (no se requiere una longitud mínima de residencia).",
  "tefap_form_checking_3": "3. El destinatario cumple con la Opción 1 y/o la Opción 2 de las pautas de elegibilidad de TEFAP anteriores.",
  "tefap_form_checking_4": "4. Este alimento es únicamente para consumo doméstico del destinatario y no se venderá, comercializará ni intercambiará.",
  "tefap_form_checking_5_1": "5. El destinatario es consciente de sus derechos civiles tal como se describen en el",
  "tefap_form_checking_5_2": "Declaración de no discriminación del USDA.",
  "tefap_out_of_state": "vives en un estado diferente",
  "and": "y",
  "or": "o",
  "exceeds": "no esta abajo",
  "not_exceeds": "no excede",
  "people": "gente",
  "person": "persona",
  "because": "porque",
  "custom_field_first_name": "Nombre",
  "custom_field_last_name": "Apellido",
  "custom_field_contact_info": "Datos de contacto",
  "custom_field_birth_date": "Cumpleaños",
  "custom_field_zip_code": "Código postal",
  "custom_field_household_size": "Tamaño de la casa",
  "custom_field_food_pickup": "Representante de recogida",
  "custom_field_emergency_contact": "Contacto de emergencia",
  "custom_field_address": "Dirección",
  "custom_field_needs_assistance": "Circunstancias especiales (necesita asistencia)",
  "custom_field_benefits_programs": "Programas de beneficios",
  "custom_field_tefap_income_eligibility": "Elegibilidad de ingresos de TEFAP",
  "custom_field_relationship_status": "Estado civil",
  "custom_field_ethnicity": "Etnicidad",
  "custom_field_education": "Educación más alta obtenida",
  "custom_field_dietary_preferences": "Preferencias alimentarias",
  "custom_field_gender": "Género",
  "custom_field_country_of_birth": "País de nacimiento",
  "custom_field_employment": "Empleo",
  "custom_field_food_preparation": "Puede preparar comida",
  "custom_field_housing": "Estado de la vivienda",
  "search": "Buscar (Nombre de despensa, Código postal, Ciudad, Estado)",
  "all": "todos",
  "pantry_filter_program_type": "Tipo de programa",
  "pantry_filter_program_type_non-food": "Sin comida",
  "pantry_filter_program_type_foodpantry": "Despensa de alimentos (comestibles gratis)",
  "pantry_filter_program_type_soupkitchen": "Comedor (comidas calientes gratis)",
  "pantry_filter_status": "Estado",
  "pantry_filter_status_all": "Todo",
  "pantry_filter_status_opennow": "Abierto ahora",
  "pantry_filter_status_opentoday": "Abierto hoy",
  "pantry_filter_status_openthisweek": "Abierto esta semana",
  "pantry_filter_status_other": "Otro",
  "pantry_filter_pantry_type": "Tipo de despensa",
  "pantry_filter_pantry_type_plentifulpantry": "Despensa abundante",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "Despensa de socios verificados",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "Despensa de socios no verificados",
  "search_no_results_found": "No se encontraron resultados",
  "search_no_pantries_match": "Ninguna despensa coincide con \"{query}\"",
  "search_try_searching_by": "Intenta buscar por:",
  "search_suggestion_city": "Nombre de ciudad (por ejemplo, \"Brooklyn\")",
  "search_suggestion_city_accessibility": "Nombre de ciudad, por ejemplo, Brooklyn",
  "search_suggestion_zipcode": "Código postal (por ejemplo, \"10001\")",
  "search_suggestion_zipcode_accessibility": "Código postal, por ejemplo, 10001",
  "search_suggestion_pantry_name": "Nombre de despensa",
  "search_suggestion_street_address": "Dirección",
  "search_accessibility_no_results": "No se encontraron resultados para {query}. Intenta buscar por nombre de ciudad, código postal, nombre de despensa o dirección.",
  "search_accessibility_no_results_generic": "No se encontraron resultados. Intenta buscar por nombre de ciudad, código postal, nombre de despensa o dirección.",
  "search_error_unable_to_display": "No se pueden mostrar los resultados de búsqueda",
  "search_error_occurred": "Ocurrió un error al mostrar los resultados de búsqueda. Por favor, intenta buscar de nuevo.",
  "accessibility_phone": "Teléfono: {phone}",
  "accessibility_email": "Correo electrónico: {email}",
  "accessibility_website": "Sitio web: {website}",
  "pantry_filter_service_type": "Tipo de servicio",
  "pantry_filter_service_type_line": "Basado en líneas",
  "pantry_filter_service_type_pre-registration": "Preinscripción",
  "pantry_filter_service_type_qr-code": "Registro con código QR",
  "pantry_filter_service_type_reservation": "Reserva",
  "program_type_benefit_enrollment": "Inscripción de beneficios",
  "program_type_emergency_services": "Servicios de emergencia",
  "program_type_non_plentiful_pantry": "Despensa no llena",
  "program_type_other_services": "Otros servicios",
  "program_type_plentiful_pantry": "Despensa abundante",
  "program_type_shelter": "Refugio",
  "program_type_soup_kitchen": "Comedor de beneficencia",
  "service_restriction_none": "Sin restricciones",
  "service_restriction_seniors": "Solo personas mayores",
  "service_restriction_families_with_children": "Familias con niños solamente",
  "service_restriction_new_clients": "Solo nuevos clientes",
  "service_restriction_existing_clients": "Solo clientes existentes",
  "filter_by_category": "Filtrar por categoría",
  "opted_out": "Parece que su número de teléfono optó por SMS para que no podamos enviarle su código de inicio de sesión. Por favor, opte nuevamente enviando mensajes de texto START a 726879 y luego intente de nuevo",
  "miles_away_singular": "A %s milla de distancia",
  "miles_away_plural": "A %s millas de distancia",
  "today": "hoy",
  "address_autocomplete_placeholder": "Comience a escribir para ver sugerencias",
  "push_notification_permissions_denied": "No se han concedido permisos para las notificaciones push. Abra la configuración del sistema y habilite las notificaciones push.",
  "push_notification_setup_error": "Se produjo un error al configurar las notificaciones push.",
  "push_notification_alternate_notifications": "Seguirás recibiendo notificaciones vía SMS o correo electrónico.",
  "loading_message": "Cómo encontrar despensas de alimentos cerca de usted",
  "location_services_no_access": "Parece que Plentiful no tiene acceso a la ubicación de tu dispositivo. Activa los servicios de ubicación de Plentiful en la configuración de tu navegador o dispositivo",
  "error_screen_header": "¡Ups! Algo salió mal.",
  "error_screen_message": "Tuvimos un problema inesperado. Puedes intentar reiniciar la aplicación o contactar con el soporte técnico.",
  "restart_app": "Reiniciar aplicación",
  "email_support": "Soporte por correo electrónico",
  "map_zoom_to_see_all": "Acerque para ver todas las ubicaciones",
  "program_eligible": "Usted es elegible para {{program}}.",
  "program_ineligible": "No cumples los requisitos para {{program}}: {{reason}}",
  "program_not_applicable": "Has completado {{program}}.",
  "program_completed": "Has completado todas las preguntas de {{program}}.",
  "program_unknown_eligibility": "Gracias por completar el formulario. El proveedor determinará su elegibilidad a su llegada."
}
